import React, { useEffect } from "react";
import coins from "../../../assets/img/coins.svg";
import { getPointedSums } from "../../../data/slices/pointedSums";
import { useDispatch, useSelector } from "../../../data/store";
import {
  convertToYYYYMM,
  formatDateStringDDMMYYYY,
} from "../../../utilities/filters";
import { formatFR } from "../../../utilities/format";
import { getAccountBadgeStyles } from "../../../utilities/colorUtils";
import Button from "../../Button";
import Overlay from "../../Overlay";
import HeaderOverlay from "../../Project/Header";
import LockIcon from "../../VirtualizedTable/TableHeaders/CreateHeaders/LockIcon";
import "./index.scss";
import { InformationIcon } from "../../VirtualizedTable/TableBody/HoverCell";

function ShowPointedSumsModal({ open, onCancel, data, ...rest }) {
  const dispatch = useDispatch();
  const { pointedSums, pointedSumsStatus, pointedSumsError } = useSelector(
    (state) => state.pointedSums
  );
  useEffect(() => {
    if (data) {
      dispatch(
        getPointedSums({
          projectId: data.projectId,
          date: convertToYYYYMM(data.month),
        })
      );
    }
  }, [data, dispatch]);

  let totalSum = 0;
  if (pointedSums) {
    if (pointedSums.every((item) => item.totalAmount == null)) {
      totalSum = null;
    } else {
      totalSum = pointedSums.reduce(
        (acc, curr) =>
          curr.totalAmount == null ? acc : acc + curr.totalAmount,
        0
      );
    }
  }

  let totalSumSign = "";
  if (totalSum < 0) {
    totalSumSign = "-";
  } else if (totalSum > 0) {
    totalSumSign = "+";
  }

  if (pointedSumsStatus === "loading") {
    return <div>Loading...</div>;
  }

  if (pointedSumsStatus === "failed") {
    return <div>Error: {pointedSumsError}</div>;
  }

  return (
    <Overlay show={open} closable={true}>
      <HeaderOverlay showlogo>
        <div className="element-centred pointed-sums-modal">
          <div className="pointed-sums-modal-header">
            <img src={coins} alt="coins" />
            <span id="confirm-delete">
              Relevé des soldes pointés pour le mois de :
            </span>
          </div>
          <span id="confirm-delete" style={{ textTransform: "capitalize" }}>
            {data?.month}
          </span>

          <div>
            <LockIcon isDisplayOnly lockStatus={data?.lockStatus} />
          </div>
        </div>

        <div
          className="pointed-sums-table"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 0.6fr",
            gap: "8px",
          }}
        >
          <div className="month-information-icon-wrapper">
            <InformationIcon
              text={
                <div>
                  Vous pouvez créer jusqu’à 9 comptes de trésorerie. Pour
                  ajouter un compte, allez dans le champ « compte de trésorerie
                  » d’une écriture !
                </div>
              }
            />
          </div>
          <div></div>
          <div className="header-table-pointed-sums">
            Dernière écriture <br /> pointée au :
          </div>
          {pointedSums.map((element) => {
            let amountSign = "";
            if (element?.totalAmount < 0) {
              amountSign = "-";
            } else if (element?.totalAmount > 0) {
              amountSign = "+";
            }

            return (
              <>
                <div className="libelle-table-pointed-sums">
                  <span
                    className="compte-displayer-filter"
                    style={getAccountBadgeStyles(element?.accountTresoColor)}
                  >
                    {element?.accountTresoCode}
                  </span>

                  <span className="libelle-table-pointed-sums-text">
                    {element?.accountTresoName}
                  </span>
                </div>
                <div className="sum-table-pointed-sums">
                  <span
                    className={`dash ${
                      element?.totalAmount > 0
                        ? "dash-positive"
                        : "dash-negative "
                    }`}
                  >
                    {amountSign}
                  </span>
                  {formatFR(element?.totalAmount) || "0,00"}
                </div>
                <div className="date-table-pointed-sums">
                  {formatDateStringDDMMYYYY(element?.lastElementDateTreso)}
                </div>
              </>
            );
          })}
          <div className="total-sum-table-pointed-sums-total">
            Total cumulé =
          </div>
          <div className="sum-table-pointed-sums total-sum-table-pointed-sums">
            <span
              className={`dash ${
                totalSum > 0 ? "dash-positive" : "dash-negative "
              }`}
            >
              {totalSumSign}
            </span>
            {formatFR(totalSum) || "0,00"}
          </div>
          <div></div>
        </div>

        <div className="verify-inputs-popup information-icon-wrapper">
          <Button
            text={"Fermer"}
            onClick={() => {
              onCancel();
            }}
            className={"action-button"}
          />
          <InformationIcon
            text={
              <div className="information-icon-text">
                Vous pouvez afficher cette fenêtre à tout moment via l’icone
                <img
                  src={coins}
                  alt="info"
                  className="information-icon-img"
                  style={{
                    filter: "invert(1)",
                    marginLeft: "5px",
                    marginRight: "5px",
                    width: "13px",
                    height: "13px",
                  }}
                />
                en pied de colonne !
              </div>
            }
          />
        </div>
      </HeaderOverlay>
    </Overlay>
  );
}

export default ShowPointedSumsModal;
